import { FooterContent } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  FooterContent,
  React
};